import base from "../../baseurl";
import token from "../../getTk";

const showAll = async (disciplineId) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const Create = await api
    .post("sport-documents/showall", {
      json: { disciplineId },
      timeout: false,
    })
    .json();
  console.log(Create);
  return Create;
};

export default showAll;
